//
// AbstractBarChart.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../Overlay";
import "../../data/ClassificationRole";
import "../../data/AnalysisRole";
import "../../core/ColorModel";
import "../../data/Role";
import "../../data/PlotRole";
import "../../core/styles/LineAttributes";
import "../../core/styles/FillAttributes";
import "../../core/styles/FillPatternAttributes";
import "./BarChartFillType";
import "./BarChartDisplay";
import "./BarChartGroupDisplay";
import "../../data/GroupOrder";
import "../../core/Orientation";
import "./BarChartGroup100";
import "../../core/styles/TextAttributes";
import "./BarChartSegmentLabelFitPolicy";
import "./DisplayBaseline";
import "../IntervalWidthType";
import "@sas-dvr/ltjs-commons/util/Dimension";

var AbstractBarChart = createModule("gtl::AbstractBarChart", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization","gtl::AbstractOverlay","gtl::Overlay"], EventDispatcher, [
    ,
    {
        barWidth: 5,
        groupOrder: 4,
        braceUpper: 1,
        isSingleResponse: 2,
        segmentLabelFormat: 7,
        includeMissingGroup: 2,
        intervalBarWidth: 1,
        fillEndAttributes: 1,
        fillPatternAttributes: 1,
        groupDisplay: 4,
        colorResponse: 1,
        intervalBarWidthType: 4,
        displayBaseline: 4,
        displayZeroLengthBar: 2,
        fillType: 4,
        baselineAttributes: 1,
        baselineIntercept: 6,
        colorModel: 1,
        group: 1,
        categorySortByResponse: 2,
        braceLower: 1,
        discreteOffset: 5,
        outlineAttributes: 1,
        orientation: 4,
        segmentLabelFitPolicy: 4,
        display: 1,
        segmentLabelAttributes: 1,
        connectAttributes: 1,
        index: 1,
        disableDataAnimationSubsetting: 2,
        target: 1,
        clusterBarWidth: 5,
        fillAttributes: 1,
        clusterWidth: 5,
        response: [1],
        category: 1,
        categorySortByRole: 1,
        braceAttributes: 1,
        group100: 4,
    },
    ,
    ,
    {
        getResolvedDisplay: [1],
    },
    ,
    ,
]);
export default AbstractBarChart;
